import Vue from 'vue'
import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        store: {
            endpoint: 'deals',

            deals: [],
            deals_amount: 50,
            deals_cursor: 0,
            deals_last: false,
            dealsLoading: false,
            currentDealsPage: 1,
            hasDealsFilter: false,

            document: null,

            autos: [],
            autos_amount: 50,
            currentAutosPage: 1,

            statusreasons: [],
            statusreasons_amount: 50,
            currentStatusReasons: 1,

            route_lists: [],
            route_lists_amount: 50,
            route_list_statuses: [],
            currentItinerariesPage: 1,

            statusesall: []
        },
        mutations: {
            setCurrentDealsPage(state, page) {
                if (page) state.currentDealsPage = page;
            },
            unshiftDeal(state, deal) {
                state.deals.unshift(deal);
            },
            setCurrentItinerariesPage(state, page) {
                if (page) state.currentItinerariesPage = page;
            },
            unshiftItinerary(state, Itinerary) {
                state.route_lists.unshift(Itinerary);
            },
            setDealFilter(state) {
                state.hasDealsFilter = true;
            },
            unsetDealFilter(state) {
                state.hasDealsFilter = false;
            }
        },
        actions: {
            getDeals({ state, rootState }, data) {
                Vue.set(state, 'dealsLoading', true);
                const concat = (data && data.concat) ? data.concat : false
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals', {params: data}).then(r => {
                    if (!r || !r.items) return [];
                    let deals = r.items;
                    if (data && concat) {
                        let dealsTemp = (state && state.deals) ? state.deals : [];
                        deals = Object.assign([], dealsTemp.concat(deals));
                    }

                    Vue.set(state, 'deals', deals);
                    Vue.set(state, 'deals_cursor', r.next);
                    Vue.set(state, 'deals_last', r.last);
                    return deals;
                }).finally(() => Vue.set(state, 'dealsLoading', false));
            },

            searchDeals({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals', {params: data}).then(r => {
                    if (!r || !r.items) return [];
                    return r.items;
                });
            },

            getDealById({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/byid/' + id).then(r => {
                    if (!r) return null
                    Vue.set(state, 'deal', r);
                    return r;
                });
            },

            getDealByIdWS({ rootState }, id) {
                // Отправляем запрос с флагом кеширования
                // Это необходимо для случая когда один менеджер обновляет или создаёт заявку,
                // а всем остальным прилетает пуш и они разом все запрашивают информацию по заявке
                // поэтому кешируем запрос чтобы не нагружать лишний раз БД
                return helpers.http.get({context: this, rootState}, '/deals/byid/' + id, { params: { cache: true } });
            },

            //удаление заявки
            deleteDeal({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/deals/byid/' + data.deal_id);
            },

            //удаление заявки
            deleteDeals({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/byidarr/delete', {ids: data.ids});
            },

            setDealStatus({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/' + data.id + '/status', data);
            },

            setDealIssueStatus({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/' + data.id + '/issue-status', data);
            },

            getDealContacts({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/deals/' + data.deal_id + '/customer_contacts', {
                    params: {type: data.type}
                });
            },



            getStatusReasons({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/status-reason', {params: data}).then(r => {
                    Vue.set(state, 'statusreasons', r.data);
                    Vue.set(state, 'statusreasons_amount', r.total);
                    return r.data;
                });
            },
            getStatusReason({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/status-reason/byid/' + id);
            },
            postStatusReason({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/status-reason', data);
            },
            putStatusReason({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/status-reason', data);
            },
            deleteStatusReason({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/deals/status-reason/byid/' + id);
            },





            //подсказка адреса
            suggest({ rootState }, data) {
                data = {
                    type: 'address',
                    count: (data.count)  ? data.count  : 50,
                    query: (data.string) ? data.string : null
                };
                return helpers.http.get({context: this, rootState}, '/suggest', {params: data}).then(r => {
                    let result = [];
                    if (r instanceof Array) result = r;
                    else result.push(r);
                    return result;
                });
            },
            getAutos({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/auto', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let deals = r.data;
                    Vue.set(state, 'autos', deals);
                    Vue.set(state, 'autos_amount', r.total);
                    return deals;
                });
            },
            getAuto({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/auto/byid/' + id);
            },
            postAuto({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/auto', data);
            },
            putAuto({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/auto', data);
            },
            deleteAuto({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/deals/auto/byid/' + id);
            },



            addFreightsToRouteList({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/route_list/' + data.id + '/freights', data);
            },

            //получение статусов заявок
            getAllStatuses({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/deals/status').then(r => {
                    Vue.set(state, 'statusesall', r);
                    return r;
                });
            },

            //получение статусов заявок
            getStatuses({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/status', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    Vue.set(state, 'deals_statuses_amount', r.total)
                    Vue.set(state, 'statuses', r.data)
                    return r.data;
                });
            },

            setManualPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, `/deals/freight/${data.freight_id}/price/set`, data);
            },
            unsetManualPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, `/deals/freight/${data.freight_id}/price/unset`, data);
            },

            setCustomPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/freight/price/set', data);
            },

            unsetCustomPrice({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/freight/price/unset', data);
            },

            recalcCustomPrice({ rootState }, dealId) {
                return helpers.http.get({context: this, rootState}, '/deals/' + dealId + '/delivery/calc');
            },

            recalcStoragePrice({ rootState }, dealId) {
                return helpers.http.get({context: this, rootState}, '/deals/' + dealId + '/storage/calc');
            },

            saveDeal({ rootState }, deal) {
                return helpers.http.post({context: this, rootState}, '/ext/dealform', deal);
            },

            getFreightById({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/freight/byid/' + id);
            },

            getFreightByIdWS({ rootState }, id) {
                // Отправляем запрос с флагом кеширования
                // Это необходимо для случая когда один менеджер обновляет или создаёт заявку,
                // а всем остальным прилетает пуш и они разом все запрашивают информацию по заявке
                // поэтому кешируем запрос чтобы не нагружать лишний раз БД
                return helpers.http.get({context: this, rootState}, '/deals/freight/byid/' + id, { params: { cache: true } });
            },            

            getFreightsByIds({ rootState }, data) {
                let params = helpers.db.resolveGetParams(data);
                params.ids = (data.ids) ? data.ids : [];
                return helpers.http.get({context: this, rootState}, '/deals/freight/byids', {params: params});
            },


            getFreightPayersServices({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/payer-services',  {params: data});
            },

            getFreigtsServices({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/deals/services', {params: data});
            },

            //прикрепление услуги к грузу
            attachFreightService({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/freight/services', data);
            },

            //прикрепление услуги к грузу
            detachFreightService({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/deals/freight/services', data);
            },

            postDocument({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/documents', {
                    user_id: data.user_id, deal_id: data.deal_id, documents: data.documents, services: data.services,
                    agent_id: (data.agent_id) ? data.agent_id : null, customer_id: (data.customer_id) ? data.customer_id : null, 
                });
            },

            putDocument({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/deals/documents/' + data.id, data);
            },

            deleteDocument({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/deals/documents/' + id);
            },

            updateDocument({ rootState }, id) {
                return helpers.http.post({context: this, rootState}, '/deals/documents/' + id + '/update');
            },

            restoreDocument({ rootState }, id) {
                return helpers.http.post({context: this, rootState}, '/deals/documents/' + id + '/restore');
            },

            getDocumentList({ state, rootState }, data) {
                const concat = (data && data.concat) ? data.concat : false
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/deals/documents', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let documents = r.data;
                    if (concat) {
                        let documentListTemp = (state && state.documents) ? state.documents : [];
                        documents = Object.assign([], documentListTemp.concat(documents));
                    }

                    Vue.set(state, 'documents', documents);
                    Vue.set(state, 'document_amount', r.total);
                });
            },

            getDocument({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/documents/byid/' + id).then(r => {
                    Vue.set(state, 'document', r);
                    return r;
                });
            },

            getDocuments({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/documents/' + id);
            },

            getRouteLists({ state, rootState }, data) {
                const concat = (data && data.concat) ? data.concat : false
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/route_list', {params: data}).then(r => {
                    let routeLists = (r && r.data) ? r.data : [];
                    const total = (r && r.total) ? r.total : 0;

                    if (concat) {
                        let temp = (state && state.route_lists) ? state.route_lists : [];
                        routeLists = Object.assign([], temp.concat(routeLists));
                    }

                    Vue.set(state, 'route_lists', routeLists);
                    Vue.set(state, 'route_lists_amount', total);
                    return routeLists;
                });
            },

            findRouteLists({ rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/route_list', {params: data}).then(r => {
                    if (!r || !r.data) return null;
                    return r.data;
                });
            },


            getRouteListById({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/route_list/' + id);
            },

            setRouteListStatus({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/route_list/' + data.id + '/status/' + data.status);
            },

            getRouteListStatuses({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/route_list/statuses').then(r => {
                    Vue.set(state, 'route_list_statuses', r);
                    return r;
                });
            },



            checkRouteListStatus({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/deals/routelist_check_status/' + id);
            },

            checkFreightOversize({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/cost/freight/' + data.freight_id + '/checkoversize', data);
            },

            setDealCapture({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/signature', data);
            },

            setDealFreightCapture({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/freight/signature', data);
            },

            sendDocumentsByEmail({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/deals/documents/email', data);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/deals/store.js